/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-03-02 16:31:52
 * @LastEditors: Jack Deng
 * @LastEditTime: 2021-06-04 19:03:01
 * @FilePath: /unifyxp-v2-store-portal/src/constrains/Query/Sort.tsx
 */
import React from 'react';
import css from './Query.less';
import DropDown from '@/src/components/Antd/DropDown/DropDown';
import GlobalButton from '@/src/components/Antd/Button/Button';
import {
  CaretUpOutlined,
  CaretDownOutlined,
  CheckOutlined,
} from '@ant-design/icons';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';

const Sort = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { name, sortList = [], sortClick, sortKey, style } = props;
  const overlaySort = (
    <div className={css.queryOverlay}>
      {sortList.map((list) => (
        <div
          className={css.overlaylist}
          onClick={() => sortClick(list)}
          key={list.key}>
          <span className={css.overlaylistIcon}>
            {sortKey === list.key && <CheckOutlined />}
          </span>
          {list.name}
        </div>
      ))}
    </div>
  );
  return sortList.length ? (
    <React.Fragment>
      <span className={css.sortByText}>{getI18n('general.sort.sortby')}</span>
      <DropDown
        className={css.dropDown}
        overlay={overlaySort}
        trigger={['click']}>
        <GlobalButton style={style}>
          {name || ''}{' '}
          <span className={css.dropDownSpan}>
            <CaretUpOutlined />
            <CaretDownOutlined />
          </span>
        </GlobalButton>
      </DropDown>
    </React.Fragment>
  ) : (
    <div></div>
  );
};
export default Sort;
